import styled from "styled-components";

export const Img = styled.img`
    margin-right: 2px;
    margin-bottom: -5px;
    fill: currentColor;
    width: 1em;
    height: 1.2em;
    display: inline-block;
    font-size: 1.5rem;
    transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    flex-shrink: 0;
    user-select: none;
    @media (max-width: 800px) {
        margin-top: -2px;
        transition: 0.2s ease-in;
    }
`;

export const Menu = styled.div`
    width: 240px;
    height: 120px;
    margin: 5px;
    padding: 15px;
    font-size: 22px;
    font-weight: bold;
    color: #095AA5;
    background: #FFF;
    border-radius: 20px;
    transition: all ease 0.8s;
    box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
    border: 1px solid rgba(0, 0, 0, 0.1);
    :hover {
        background-color: #095AA5;
        color: #FFF;
    }
`;
